module.exports = __webpack_public_path__ + "img/01020501.a9cd7549.svg";